export type ParticleType = 'sand' | 'water' | 'stone' | 'wood' | 'fire' | 'smoke' | 'charcoal' | 'lava' | 'gravel' | 'eraser' | 'mixer' | 'drag' | 'heater' | 'crusher' | 'glue' | 'ice' | 'cooler' | 'steam' | 'oil' | 'filter' | 'saltpeter' | 'sulfur' | 'gunpowder' | 'bedrock';

export const MATERIALS: { type: ParticleType; label: string; shortcut: string }[] = [
    { type: 'bedrock', label: '基岩', shortcut: 'b' },
    { type: 'sand', label: '沙子', shortcut: 's' },
    { type: 'water', label: '水', shortcut: 'w' },
    { type: 'oil', label: '石油', shortcut: 'o' },
    { type: 'steam', label: '水蒸气', shortcut: 't' },
    { type: 'ice', label: '冰', shortcut: 'i' },
    { type: 'gunpowder', label: '火药', shortcut: 'n' },
    { type: 'saltpeter', label: '硝石', shortcut: 'p' },
    { type: 'sulfur', label: '硫磺', shortcut: 'y' },
    { type: 'stone', label: '石头', shortcut: 'r' },
    { type: 'gravel', label: '碎石', shortcut: 'v' },
    { type: 'wood', label: '木头', shortcut: 'd' },
    { type: 'fire', label: '火', shortcut: 'f' },
    { type: 'lava', label: '熔岩', shortcut: 'l' },
    { type: 'smoke', label: '烟', shortcut: 'q' },
    { type: 'charcoal', label: '木炭', shortcut: 'c' },
];

export const ACTIONS: { type: ParticleType; label: string; shortcut: string }[] = [
    { type: 'eraser', label: '橡皮擦', shortcut: 'e' },
    // { type: 'filter', label: '过滤器', shortcut: 'b' },
    { type: 'mixer', label: '搅拌器', shortcut: 'm' },
    { type: 'heater', label: '加热器', shortcut: 'h' },
    { type: 'cooler', label: '冷却器', shortcut: 'k' },
    { type: 'crusher', label: '粉碎机', shortcut: 'z' },
    { type: 'glue', label: '胶水', shortcut: 'u' },
    { type: 'drag', label: '拖拽', shortcut: 'g' },
];

export const TOOLS = [...MATERIALS, ...ACTIONS];

export const PARTICLE_NAMES: Record<string, string> = {
    'Sand': '沙子',
    'Water': '水',
    'Stone': '石头',
    'Gravel': '碎石',
    'Wood': '木头',
    'Fire': '火',
    'Lava': '熔岩',
    'Smoke': '烟',
    'Charcoal': '木炭',
    'Empty': '空气',
    'Drag': '拖拽',
    'heater': '加热器',
    'cooler': '冷却器',
    'crusher': '粉碎机',
    'glue': '胶水',
    'Ice': '冰',
    'Steam': '水蒸气',
    'Oil': '石油',
    'Sawdust': '木屑',
    'Filter': '过滤器',
    'Saltpeter': '硝石',
    'Sulfur': '硫磺',
    'Gunpowder': '火药',
    'Bedrock': '基岩',
};
